import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { ConsequenceItem, ProbabilityOfFailureItem } from '../types/risk-config.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsequenceService {
  constructor(private http: HttpClient) { }
  
  private consequenceItems: ConsequenceItem[] = [];
  private cache: Map<string, ConsequenceItem[]> = new Map();
  private dataLoaded: boolean = false;
  
  private readonly url = `${environment.API_INSPEC}Consequence`

  getConsequenceItems(customerId: string): Observable<ConsequenceItem[]> {
    // TODO - Make a better caching
    // if (this.dataLoaded) {
    //   const filteredItems = this.consequenceItems.filter(item => item.customerId === customerId);
    //   if (filteredItems.length > 0) {
    //     return of(filteredItems);
    //   }
    // }

    return this.fetchConsequenceItemsFromServer(customerId);
  }

  private fetchConsequenceItemsFromServer(customerId: string): Observable<ConsequenceItem[]> {
    return this.http.get<ConsequenceItem[]>(`${this.url}/GetConsequenceItems?customerId=${customerId}`).pipe(
      map(items => items.map(item => ({ ...item, type: 'consequence' } as ConsequenceItem))),
      tap(items => {
        this.consequenceItems = [...this.consequenceItems, ...items];
        this.dataLoaded = true;
      }),
      catchError(error => {
        console.error('Failed to fetch items', error);
        return of([] as ConsequenceItem[]);
      })
    );
  }
  
  getCachedConsequenceItems(customerId: string): Observable<ConsequenceItem[]> {
    if (this.cache.has(customerId)) {
      console.log('Returning consequence data from cache for customer:', customerId);
      return of(this.cache.get(customerId)!);
    }
    return this.fetchAndCacheConsequenceItems(customerId);
  }

  private fetchAndCacheConsequenceItems(customerId: string): Observable<ConsequenceItem[]> {
    return this.http.get<ConsequenceItem[]>(`${this.url}/GetConsequenceItems?customerId=${customerId}`).pipe(
      map(items => items.map(item => ({ ...item, type: 'consequence' } as ConsequenceItem))),
      tap(items => {
        console.log('Caching consequence data for customer:', customerId);
        this.cache.set(customerId, items);
      }),
      catchError(error => {
        console.error('Failed to fetch consequence items', error);
        return of([] as ConsequenceItem[]);
      })
    );
  }

  getConsequenceItem(id: string): Observable<ConsequenceItem> {
    return this.http.get<ConsequenceItem>(this.url + `/${id}`);
  }

  postConsequenceItem(consequenceItem: ConsequenceItem) {
    return this.http.post<{ id: string }>(this.url, consequenceItem);
  }

  putConsequenceItem(consequenceItem: ConsequenceItem) {
    return this.http.put(this.url, consequenceItem);
  }

  deleteConsequenceItem(id: string) {
    return this.http.delete<boolean>(this.url + `?id=${id}`);
  }
}
